import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../shared/sharedData';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom }from '../shared/services/http.client';
import * as _ from 'underscore';
import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'Crop-Image',
    templateUrl: 'imageCropper.html'
})
export class CropImageComponent {
    cropperSettings: CropperSettings;
    data: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';

    @ViewChild('cropper', undefined)
    cropper: ImageCropperComponent;

    public localState: any;
    public _baseUrl: any;
    public employeeId: any;
    constructor(
        public route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate: TranslateService,
        public share: SharedData,
    ) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.cropperSettings = new CropperSettings();
        this.cropperSettings.noFileInput = true;
        this.cropperSettings.rounded = true;
        // minWithRelativeToResolution=false preserveSize=true compressRatio=0 dynamicSizing=true
        this.cropperSettings.minWithRelativeToResolution = true;
        this.cropperSettings.preserveSize = true;
        this.cropperSettings.dynamicSizing = true;
        // this.cropperSettings.preserveSize = true;
        // this.cropperSettings.canvasWidth = 600;
        // this.cropperSettings.canvasHeight = 400;
        this.data = {};
        this.fileChangeListener(this.share.getData());
    }
    
    fileChangeListener($event) {
        var image: any = new Image();
        var file: File = $event.target.files[0];
        var myReader: FileReader = new FileReader();
        var that = this;
        myReader.onloadend = function (loadEvent: any) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);
        };
        myReader.readAsDataURL(file);
    }
    confirmCrop() {
        this.activeModal.close(this.data);
    }
}



// WEBPACK FOOTER //
// ./src/app/imageCropper/imageCropper.ts